import { LOADER_STATUS } from "./constants";

export const initialState = {
  loaderStatus: false,
};

const gstr8CashBalanceReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADER_STATUS:
      return {
        ...state,
        loaderStatus: action.loaderStatus,
      };

    default:
      return state;
  }
};

export default gstr8CashBalanceReducer;
